import { render, staticRenderFns } from "./IndividualRating.vue?vue&type=template&id=90da6b2a&scoped=true&"
import script from "./IndividualRating.vue?vue&type=script&lang=js&"
export * from "./IndividualRating.vue?vue&type=script&lang=js&"
import style0 from "./IndividualRating.vue?vue&type=style&index=0&id=90da6b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da6b2a",
  null
  
)

export default component.exports